function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from "prop-types";
import { Component } from "react";
import { Result } from "@elastic/react-search-ui-views";
import { withSearch } from "..";
import { Result as ResultType } from "../types";
export var ResultContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ResultContainer, _Component);

  function ResultContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ResultContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ResultContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickLink", function (id) {
      var _this$props = _this.props,
          clickThroughTags = _this$props.clickThroughTags,
          shouldTrackClickThrough = _this$props.shouldTrackClickThrough,
          trackClickThrough = _this$props.trackClickThrough;

      if (shouldTrackClickThrough) {
        trackClickThrough(id, clickThroughTags);
      }
    });

    return _this;
  }

  _createClass(ResultContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          result = _this$props2.result,
          titleField = _this$props2.titleField,
          urlField = _this$props2.urlField,
          view = _this$props2.view;
      var View = view || Result;
      return View({
        className: className,
        result: result,
        key: "result-".concat(result.id.raw),
        onClickLink: function onClickLink() {
          return _this2.handleClickLink(result.id.raw);
        },
        titleField: titleField,
        urlField: urlField
      });
    }
  }]);

  return ResultContainer;
}(Component);

_defineProperty(ResultContainer, "propTypes", {
  // Props
  className: PropTypes.string,
  clickThroughTags: PropTypes.arrayOf(PropTypes.string),
  titleField: PropTypes.string,
  urlField: PropTypes.string,
  view: PropTypes.func,
  result: ResultType.isRequired,
  shouldTrackClickThrough: PropTypes.bool,
  // Actions
  trackClickThrough: PropTypes.func
});

_defineProperty(ResultContainer, "defaultProps", {
  clickThroughTags: [],
  shouldTrackClickThrough: true
});

export default withSearch(function (_ref) {
  var trackClickThrough = _ref.trackClickThrough;
  return {
    trackClickThrough: trackClickThrough
  };
})(ResultContainer);